// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
	//TODO: write your page related code here...
	if($w('#quickActionBar1').isVisible)
	$w('#quickActionBar1').collapse();
	}
});